export default __webpack_public_path__ + "static/media/840.ac9d32ab.gif";